import { Component, HostListener, OnInit } from '@angular/core';
import { LocalStorageService } from '@g99-product-web-ui/shared-service';
import { HOLIDAY_READY_BANNER_CONFIG } from '@g99-product-web-ui/shared-util-lib';

/**
 * Black Friday "holiday-ready" announcement: a bar above the other app banners whose details
 * expand inline below it. Closing it hides it in this browser until the campaign ends.
 */
@Component({
  selector: 'g99-lib-holiday-ready-banner',
  templateUrl: './holiday-ready-banner.component.html',
  styleUrl: './holiday-ready-banner.component.scss',
  standalone: false,
})
export class HolidayReadyBannerComponent implements OnInit {
  protected readonly config = HOLIDAY_READY_BANNER_CONFIG;
  protected isVisible = false;
  protected isPanelOpen = false;

  constructor(private readonly _localStorageService: LocalStorageService) {}

  @HostListener('document:keydown.escape')
  protected closePanel(): void {
    this.isPanelOpen = false;
  }

  public ngOnInit(): void {
    const closed = this._localStorageService.readItem(this.config.storageKey);
    this.isVisible =
      closed !== true && Date.now() < new Date(this.config.endsAt).getTime();
  }

  protected togglePanel(): void {
    this.isPanelOpen = !this.isPanelOpen;
  }

  protected closeBanner(): void {
    this.isPanelOpen = false;
    this.isVisible = false;
    this._localStorageService.storeItem(this.config.storageKey, true);
  }
}
